import type { ObbPassenger } from "./types";
import { DEFAULT_OBB_PASSENGER_TYPE_CODE } from "./obbPassengerTypes";

export const createInitialObbPassenger = (hasRemove = false): ObbPassenger => ({
  first_name: "",
  last_name: "",
  passenger_type: DEFAULT_OBB_PASSENGER_TYPE_CODE,
  hasRemove
});
